import React from 'react'
import {JsxElement} from 'typescript'

function generateContext<Type>(
    contextType: React.Context<Type>
): [(props: {children: React.ReactNode; value: any}) => JSX.Element, any] {
    const useNewContext = () => {
        const context = React.useContext(contextType)
        if (!context) throw Error('useContext must be used within expected context')
        return context as Type
    }
    const provider = (props: {children: React.ReactNode; value: any}) => {
        return <contextType.Provider value={props.value}>{props.children}</contextType.Provider>
    }
    return [provider, useNewContext]
}

export default generateContext
